module.exports = __webpack_public_path__ + "img/resources-1920.16fc0eb5.jpg";